/* Isolated Pet launch: static examples only; no generation or cart requests. */
(function () {
  'use strict';
  if (window.CCLPetLaunch) { window.CCLPetLaunch.init(document); return; }
  const states = new Map(), portraits = new Map(), motion = matchMedia('(prefers-reduced-motion: reduce)');
  const seenMemory = new Set();
  function loadPortrait(host) {
    const src = host.dataset.petSrc, name = host.dataset.petName, key = src + '|' + name + '|' + host.dataset.petComposed;
    if (!portraits.has(key)) portraits.set(key, new Promise((resolve, reject) => {
      const image = new Image(); image.crossOrigin = 'anonymous';
      image.onerror = () => reject(Error('Esempio non disponibile.'));
      image.onload = async () => {
        try {
          if (host.dataset.petComposed === 'true') { resolve(image); return; }
          await (document.fonts?.ready || Promise.resolve());
          if (!window.CCLDogueCover) throw Error('Compositore non disponibile.');
          resolve(window.CCLDogueCover.render({ image, width: 900, height: 1200, name, color: '#252e49', fontFamily: 'Georgia', coverLines: [] }));
        } catch (error) { reject(error); }
      };
      image.src = src;
    }).catch(error => { portraits.delete(key); throw error; }));
    return portraits.get(key);
  }
  function inViewport(element) {
    const box = element.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 && box.top < innerHeight && box.left < innerWidth;
  }
  function visible(element) {
    return element && !element.hidden && inViewport(element) && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none';
  }
  function syncMotion(state) {
    for (const record of state.models) record.host.dataset.petMotion = !state.paused && !motion.matches && !document.hidden && record.inView && (!state.popup || state.root.open) ? 'running' : 'paused';
  }
  async function mountModels(state) {
    if (state.mounted || state.disposed) return; state.mounted = true;
    await Promise.all(Array.from(state.root.querySelectorAll('[data-pet-stage]'), async host => {
      try {
        const canvas = await loadPortrait(host); if (state.disposed || !host.isConnected) return;
        const fallback = host.querySelector('[data-pet-fallback]');
        if (!window.CCL3D) { fallback.src = typeof canvas.toDataURL === 'function' ? canvas.toDataURL('image/jpeg', .9) : canvas.src; return; }
        const model = new window.CCL3D.CanvasModel(host, { interactive: false, compact: true });
        model.set(canvas, { x: 0, y: 0, w: canvas.naturalWidth || canvas.width, h: canvas.naturalHeight || canvas.height }, 30, 40);
        model.setView('perspective'); fallback.hidden = true;
        const record = { host, model, inView: inViewport(host) }; state.models.push(record); state.observer?.observe(host); syncMotion(state);
      } catch (_) { /* The original static example remains visible. */ }
    }));
  }
  function readSeen(key) {
    if (seenMemory.has(key)) return true;
    for (const type of ['localStorage', 'sessionStorage']) try { if (window[type].getItem(key)) return true; } catch (_) {}
    return false;
  }
  function remember(key, value) {
    seenMemory.add(key); let saved = false;
    for (const type of ['localStorage', 'sessionStorage']) try { window[type].setItem(key, value); saved = true; } catch (_) {}
    return saved;
  }
  function storageAvailable() {
    for (const type of ['localStorage', 'sessionStorage']) try {
      const storage = window[type], key = 'ccl-pet-launch-check'; storage.setItem(key, '1'); storage.removeItem(key); return true;
    } catch (_) {}
    return false;
  }
  function unlockScroll(state) {
    if (!state.scrollLocked) return;
    document.body.style.overflow = state.previousOverflow; document.body.style.paddingRight = state.previousPadding;
    state.scrollLocked = false;
  }
  function closePopup(state, dismissed = true) {
    if (dismissed) remember(state.key, 'dismissed');
    if (state.root.open) state.root.close();
    unlockScroll(state); syncMotion(state);
    if (state.previousFocus?.isConnected) state.previousFocus.focus({ preventScroll: true });
  }
  function dispose(state, remove = false) {
    if (state.disposed) return; clearTimeout(state.timer); clearTimeout(state.expiryTimer);
    if (state.popup) closePopup(state, false);
    state.disposed = true; state.controller.abort(); state.observer?.disconnect();
    for (const record of state.models) record.model.destroy();
    states.delete(state.root); if (remove) state.root.remove();
  }
  function blocked(state) {
    if (document.hidden || document.querySelector('[data-dogue]')) return true;
    if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
    if (Array.from(document.querySelectorAll('input[type="file"]')).some(input => input.files?.length)) return true;
    if (Array.from(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')).some(element => element !== state.root && visible(element))) return true;
    if (Array.from(document.querySelectorAll('[data-ccl-privacy]:not([hidden]),details.ccl-original-mobile[open],[data-ai-loader]:not([hidden]),[data-dogue-loader]:not([hidden]),.is-generating')).some(visible)) return true;
    const cart = document.querySelector('[data-cart-popup-wrapper]'); return cart && !cart.classList.contains('cart-popup-wrapper--hidden') && visible(cart);
  }
  function attemptPopup(state) {
    if (state.disposed) return;
    const now = Date.now();
    if (now >= state.end) { dispose(state, true); return; }
    if (readSeen(state.key)) return;
    if (now < state.start || blocked(state)) { state.timer = setTimeout(() => attemptPopup(state), 1500); return; }
    state.previousFocus = document.activeElement;
    try { state.root.showModal(); } catch (_) { return; }
    remember(state.key, 'seen');
    state.previousOverflow = document.body.style.overflow; state.previousPadding = document.body.style.paddingRight;
    const gap = Math.max(0, innerWidth - document.documentElement.clientWidth);
    if (gap) document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) || 0) + gap + 'px';
    document.body.style.overflow = 'hidden'; state.scrollLocked = true;
    mountModels(state); state.root.querySelector('[data-pet-close]').focus({ preventScroll: true }); syncMotion(state);
  }
  function init(scope) {
    scope.querySelectorAll('[data-pet-launch]').forEach(root => {
      if (states.has(root)) return;
      const state = { root, popup: root.dataset.petPlacement === 'popup', models: [], mounted: false, disposed: false, paused: false, controller: new AbortController() };
      states.set(root, state); const listen = (element, type, fn) => element.addEventListener(type, fn, { signal: state.controller.signal });
      if (window.IntersectionObserver) state.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === root && entry.isIntersecting) { state.observer.unobserve(root); mountModels(state); }
          const record = state.models.find(item => item.host === entry.target); if (record) record.inView = entry.isIntersecting;
        }
        syncMotion(state);
      }, { threshold: .02 });
      else listen(window, 'scroll', () => { if (!state.popup && !state.mounted && inViewport(root)) mountModels(state); for (const record of state.models) record.inView = inViewport(record.host); syncMotion(state); });
      listen(window, 'pagehide', () => { if (state.popup && state.root.open) closePopup(state, false); });
      listen(window, 'pageshow', () => { if (state.popup && Date.now() >= state.end) dispose(state, true); else { if (state.popup && state.root.open && readSeen(state.key)) closePopup(state, false); syncMotion(state); } });
      listen(document, 'visibilitychange', () => {
        if (state.popup && Date.now() >= state.end) dispose(state, true); else syncMotion(state);
      });
      const motionButton = root.querySelector('[data-pet-motion-toggle]');
      const updateMotion = () => { if (motionButton) { motionButton.hidden = motion.matches; motionButton.textContent = state.paused ? 'Attiva movimento' : 'Pausa movimento'; motionButton.setAttribute('aria-pressed', String(state.paused)); } syncMotion(state); };
      if (motionButton) listen(motionButton, 'click', () => { state.paused = !state.paused; updateMotion(); });
      if (motion.addEventListener) listen(motion, 'change', updateMotion); updateMotion();
      listen(document, 'shopify:section:unload', event => { if (event.target.contains(root)) dispose(state); });
      if (!state.popup) { if (state.observer) state.observer.observe(root); else if (inViewport(root)) mountModels(state); return; }
      state.start = Number(root.dataset.petStart) * 1000; state.end = Number(root.dataset.petEnd) * 1000;
      state.key = 'ccl-pet-launch:' + root.dataset.petStart + ':' + root.dataset.petEnd;
      if (!Number.isFinite(state.start) || !Number.isFinite(state.end) || state.end <= state.start || Date.now() >= state.end || !storageAvailable() || typeof root.showModal !== 'function') { dispose(state, true); return; }
      state.expiryTimer = setTimeout(() => dispose(state, true), Math.max(0, state.end - Date.now()));
      listen(root, 'cancel', event => { event.preventDefault(); closePopup(state); });
      listen(root, 'close', () => { unlockScroll(state); syncMotion(state); if (state.previousFocus?.isConnected) state.previousFocus.focus({ preventScroll: true }); });
      root.querySelectorAll('[data-pet-close]').forEach(button => listen(button, 'click', () => closePopup(state)));
      root.querySelectorAll('a[href]').forEach(link => listen(link, 'click', () => closePopup(state, false)));
      listen(root, 'click', event => {
        if (event.target !== root) return; const box = root.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closePopup(state);
      });
      listen(window, 'storage', event => { if (event.key === state.key && event.newValue && root.open) closePopup(state, false); });
      if (!readSeen(state.key)) state.timer = setTimeout(() => attemptPopup(state), 5000);
    });
  }
  window.CCLPetLaunch = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
